import * as types from '../index';

export const userDocMasterListAction = (data) => {
    return {
    type: types.USER_DOC_MASTER_LIST,
    data
    }
};

export const userDocListAction = (data) => {
    return {
    type: types.USER_DOC_LIST,
    data
    }
};

export const userDocAddAction = (data) => {
    return {
    type: types.USER_DOC_ADD,
    data
    }
};

export const userDocEditAction = (data) => {
    return {
    type: types.USER_DOC_EDIT,
    data
    }
};

export const userDocUpdateAction = (data) => {
    return {
    type: types.USER_DOC_UPDATE,
    data
    }
};

export const userDocDeleteAction = (data) => {
    return {
    type: types.USER_DOC_DELETE,
    data
    }
};